import { useState, useRef, useCallback } from "react";

export function usePaneResizer() {
  const [dividerX, setDividerX] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleDividerMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      const startX = e.clientX;
      const container = containerRef.current;
      if (!container) return;
      const startWidth =
        dividerX ?? container.getBoundingClientRect().width - 480;
      const onMove = (me: MouseEvent) => {
        const dx = me.clientX - startX;
        setDividerX(
          Math.max(
            220,
            Math.min(
              startWidth + dx,
              container.getBoundingClientRect().width - 360,
            ),
          ),
        );
      };
      const onUp = () => {
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
      };
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onUp);
    },
    [dividerX],
  );

  return { dividerX, containerRef, handleDividerMouseDown };
}
